import styled from "styled-components";
import InaingImg from "../../../assets/images/logo/ina-ing-logo.png";
import { Theme } from "../../themes/theme";

const PayChip = styled.div`
  width: fit-content;
  font-size: ${Theme.font.fontSize.sm};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 8px;
  border: 1px solid ${Theme.color.border.light};
  color: ${Theme.color.text.secondary};
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s;

  background-color: ${Theme.color.default.white};
`;
function DevelopedByChip() {
  return (
    <PayChip
      onClick={() => {
        window.location.href = "https://inaing.com";
      }}
    >
      Developed By <img src={InaingImg} alt="Inaing Tech" height={"16px"} />
    </PayChip>
  );
}

export default DevelopedByChip;
